<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for>
              <small>{{label}}</small>
            </label>
            <pnet-date-picker
              inputClass="form-control"
              dpcalendarClass="datepicker__calendar"
              :dateFormat="format !== undefined ? format : 'dd/MM/yyyy'"
              v-model="rawValue"
              :dplanguage="it"
              :autofix="false"
              :delimiter="'/'"
              :input-placeholder="placeholder != undefined ? placeholder : 'GG/MM/AAAA'"
              :name="label"
              :rules="{required:true}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
            ></pnet-date-picker>
          </div>
        </div>
      </div>
      <div v-if="!label">
        <pnet-date-picker
          inputClass="form-control"
          dpcalendarClass="datepicker__calendar"
          :dateFormat="format !== undefined ? format : 'dd/MM/yyyy'"
          v-model="rawValue"
          :dplanguage="it"
          :autofix="false"
          :delimiter="'/'"
          :input-placeholder="placeholder != undefined ? placeholder : 'GG/MM/AAAA'"
          :name="label"
          :rules="{required:true}"
          :customMessages="{required:'Il campo deve essere valorizzato.'}"
        ></pnet-date-picker>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
export default Vue.extend({
  components: {
    PnetDatePicker,
  },
  data: function() {
    return {
      rawValue: null,
      it
    }
  },
  mounted() {
    this.rawValue = this.value;
  },
  props: ["label","value","format","placeholder"],
  methods: {},
  watch: {
    rawValue: {
      deep: true,
      handler(){
        this.$emit('input', this.rawValue);
      }
    },
    value: {
      deep: true,
      handler(){
        this.rawValue = this.value;
      }
    }
  }
});
</script>
